import React, { useState } from "react";
import { Building2 } from "lucide-react";

interface Organization {
  id: string;
  name: string;
}

interface Props {
  organizations: Organization[];
  onSelect: (organizationId: string) => void;
}

export const OrganizationSelectorModal: React.FC<Props> = ({
  organizations,
  onSelect,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSelect = (id: string) => {
    setSubmitting(true);
    onSelect(id);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-5 pt-20 pb-10 sm:pt-28 sm:pb-14 bg-black/40 backdrop-blur-sm">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-bridge-border/60">
        <div className="flex items-center justify-between px-6 py-4 border-b border-bridge-border/60">
          <div>
            <h2 className="text-lg font-bold text-bridge-fg">Select Organization</h2>
            <p className="text-xs text-bridge-muted mt-0.5">
              Your email is associated with multiple organizations.
            </p>
          </div>
        </div>

        <div className="p-6 space-y-4 max-h-[60vh] overflow-y-auto">
          {organizations.map((org) => (
            <button
              key={org.id}
              disabled={submitting}
              onClick={() => handleSelect(org.id)}
              className="w-full flex items-center gap-4 p-4 text-left border border-bridge-border/60 rounded-xl hover:border-bridge-accent hover:bg-bridge-accent/5 transition-all focus:outline-none focus:ring-2 focus:ring-bridge-accent/50 disabled:opacity-50"
            >
              <div className="w-10 h-10 rounded-full bg-bridge-accent/10 flex items-center justify-center text-bridge-accent shrink-0">
                <Building2 size={20} />
              </div>
              <div>
                <div className="font-semibold text-bridge-fg">{org.name}</div>
                <div className="text-xs text-bridge-muted truncate">ID: {org.id}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
